import React, { useEffect, useState } from 'react';
import PhoneInput, { Value } from 'react-phone-number-input';
import clsx from 'clsx';

import { BaseInputProps } from '@utils/types/baseComponents';

import styles from './styles.module.scss';

export function PhoneNumberInput(
  props: Omit<BaseInputProps, 'type'> & {
    noError?: boolean;
  }
) {
  const {
    containerStyle,
    required,
    label,
    name,
    error,
    touched,
    onTextChange,
    onFocus,
    onBlur,
    placeholder,
    defaultValue = null,
    noError = false,
  } = props;
  const [value, setValue] = useState<Value | string>();

  useEffect(() => {
    if (defaultValue) setValue(defaultValue);
  }, [defaultValue]);

  const onChange = (value: string) => {
    setValue(value);
    onTextChange && onTextChange(value);
  };

  return (
    <div className={clsx([styles.container, containerStyle])}>
      <span>{label || 'Mobile Number'}</span>
      {/* @ts-ignore */}
      <PhoneInput
        numberInputProps={{
          required,
          name,
        }}
        international
        name="phone"
        value={value}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        defaultCountry="US"
        withCountryCallingCode
        placeholder={placeholder || 'Enter phone number'}
        className={styles.phoneInput}
      />

      {!noError && (
        <div className={styles.error}>
          {!!error && touched && <li>{error}</li>}
        </div>
      )}
    </div>
  );
}
